export const GET_CALLBACKS = "GET_CALLBACKS";
export const GET_CALLBACKS_SUCCESS = "GET_CALLBACKS_SUCCESS";
export const GET_CALLBACKS_ERROR = "GET_CALLBACKS_ERROR";
